<!-- <div
    [@sliderAnimation]="selectedIndex"
    slideControl
    [itemsLength]="itemsLength"
    [autoStart]="autoStart"
    #ctrl="slideControl"
    (selectedIndex)="selectedIndex = $event"
    (actualIndex)="actualIndex = $event"
    kwSetSlideContainerHeight
    class="slide-container">
    <div *ngFor="let slide of items" class="slide">
        <div class="item-wrapper" *ngFor="let item of slide;let i = index" [class]="'cell-'+i">
            <div class="image-wrapper">
                <img src="{{item?.imgSrc}}" alt="">
            </div>
        </div>
    </div>
</div> -->
<div
    slideControl
    [itemsLength]="itemsLength"
    [autoStart]="autoStart"
    #ctrl="slideControl"
    (selectedIndex)="selectedIndex = $event"
    (actualIndex)="actualIndex = $event"
    kwSetSlideContainerHeight
    class="slide-container">
    <div class="grid-container" [class]="'state-'+actualIndex" #gridContainer>
        <div class="item-wrapper" *ngFor="let slide of slides;let i = index" [class]="'cell-'+i">
            <div class="image-wrapper">
                <img src="{{slide?.imgSrc}}" alt="">
            </div>
        </div>
    </div>
</div>
